exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".TTPFilterHorizontalBar-local__count_item--Lwh_v {\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -ms-flex-align: center;\n      align-items: center;\n  gap: 6px;\n  font-size: 11.5px;\n  font-weight: 400;\n  color: #3c4e64; }\n  .TTPFilterHorizontalBar-local__count_item--Lwh_v p {\n    padding: 0px 7px;\n    display: inline-block;\n    background: #f1f2f4;\n    border-radius: 2px;\n    font-weight: 400;\n    font-size: 12px;\n    margin: 0; }\n", ""]);

// exports
exports.locals = {
	"count_item": "TTPFilterHorizontalBar-local__count_item--Lwh_v"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"localIdentName":"[name]__[local]--[hash:base64:5]","importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["/home/runner/work/team/team/src","node_modules/foundation-sites/scss","node_modules/motion-ui/src"]}!./src/components/Common/filters/TTPFilterHorizontalBar.local.scss
// module id = 1923
// module chunks = 0